export default __webpack_public_path__ + "static/lisa-9fc8ad4c2c030e1406a2b168e80e0d8f.png";